import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';

class OnOrdersModal extends Component {
  fetchData() {
    const {code, invoice} = this.props;
    this.props.fetchInvoicesConfirmedDetail(code, invoice);
  }

  getMoneyValue(value = 0) {
    return `$${getNumericValue(value, 2)}`;
  }

  renderItems() {
    const {invoicesConfirmedData} = this.props;

    if (!invoicesConfirmedData.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={8}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return invoicesConfirmedData.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.caseNumber}</Table.Cell>
          <Table.Cell textAlign='center'>{element.orderCode}</Table.Cell>
          <Table.Cell textAlign='right'>{element.partWeight}</Table.Cell>
          <Table.Cell textAlign='right'>{element.quantity}</Table.Cell>
          <Table.Cell textAlign='right'>{this.getMoneyValue(element.unitCost)}</Table.Cell>
          <Table.Cell textAlign='right'>{this.getMoneyValue(element.totalCost)}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }

  renderPartData() {
    const {invoicesConfirmedData} = this.props;
    if (!invoicesConfirmedData.length) {
      return '';
    }
    return `${invoicesConfirmedData[0].partCode} | ${invoicesConfirmedData[0].partName} | `;
  }
  
  render() {
    const {invoice, invoicesConfirmedData} = this.props;

    return (
      <Modal size={'small'} onOpen={() => this.fetchData()}
        trigger={<div className='link'>
          {invoice}
        </div>} closeIcon>

        <Modal.Header>
          En Tránsito | {this.renderPartData()} Factura {invoice}
          <span className='quantity-container'>
            {_.sumBy(invoicesConfirmedData, 'quantity')}
          </span>
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>

            <Table striped className='toyota-grid'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>Case No.</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Pedido</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Peso</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Cantidad</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Precio Unitario</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Valor Total</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
          
              <Table.Body>
                {this.renderData()}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingInvoicesConfirmedDetail,
    'invoicesConfirmedData': state.partModals.invoicesConfirmedDetail,
  };
};

const {
  fetchInvoicesConfirmedDetail,
} = Actions;

export default connect(mapStateToProps, {
  fetchInvoicesConfirmedDetail,
})(OnOrdersModal);
